// Shared date formatting helpers — South African display format (dd/mm/yyyy).
// Built manually (pad-and-join) so the output is guaranteed regardless of the
// browser/OS locale. Native <input type="date"> pickers are NOT affected by
// these helpers — their display follows the user's locale and their value stays
// ISO (yyyy-mm-dd).

const toDate = (value) => {
  if (value == null || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

const pad = (n) => String(n).padStart(2, '0');

// dd/mm/yyyy
export function formatDate(value, fallback = '—') {
  const d = toDate(value);
  if (!d) return fallback;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// dd/mm/yyyy HH:mm (24-hour)
export function formatDateTime(value, fallback = '—') {
  const d = toDate(value);
  if (!d) return fallback;
  return `${formatDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
